export enum ExperimentVariant {
    VARIANT_A = 'A',
    VARIANT_B = 'B',
    VARIANT_C = 'C',
    VARIANT_D = 'D',
}

export const GrowthBookFeature = {
    REVIEW_FEATURE_FLAG: 'GTC-2380',
    UNREAD_FEATURE_FLAG: 'GTC-2379',
    FORGOTTEN_PASSWORD_FLAG: 'GTC-2643',
    LOGOUT_TO_BFF: 'GTCON-20',
    EXPIRED_ADS_BANNER: 'GTS-74',
    MCUFEED_CTA_CHANGE: 'GTCON-91',
    DATE_OF_BIRTH_INPUT: 'GTCON-42',
    HIDE_SMS: 'GTCON-274',
    NEW_FEATURES_COPY: 'GTS-142',
    LISTING_CAP_MODAL: 'GTS-105',
    REVEAL_NUMBER_LABEL: 'GTCON-331',
    POSTCODE_INPUT: 'GTCON-275',
    GOOGLE_REVIEW_SRP: 'google-review-srp',
    GBG_VERIFY: 'gbg-verify',
    // sug search
    SUG_WITHOUT_CATEGORY: 'sug_without_category',
    BLOCKTHROUGH_JS: 'blockthrough-ad-script',
    PRE_AD_SOURCE: 'pre-ad-source',
    PREBID_TIMEOUT: 'prebid-timeout',
    ADSENCE_ADMARKETPLACE: 'adsence-admarketplace',
    // vip phone number required
    VIP_CLICK_PHONE_NUMBER_REQUIRED: 'vip_click_phone_number_required',
    NEW_MAKE_OFFER: 'e_001',
    AD_PLACEHOLDER: 'bid02',
    MICRO_BIDDERS: 'bid01',
    LOGIN_APPLE: 'login01',
    // for sale listing caps
    FOR_SALE_SELLER_TYPE_BUYER: 'Listing-Caps-Seller-Type-Buyer',
    FEATURE_AD_OPTIMISATION: 'feature-ad-optimisation',
    NEARBY_LISTING_NEW_ADS: 'nearby-listing-new-ads',
    CONSENT_2: 'consent_2',
    // new reply message
    REPLY_MESSAGE_MIGRATION: 'GT1226',
    // motorway
    MTWAY: 'mtway',
    // services landing
    E_002: 'e_002',
    ADSENSE_QUERY: 'adsense-query',
    HOMEP: 'homep',
    SRP_1: 'srp1',
    SRP_2: 'srp2',
    SRP_3: 'srp3',
    SRP_4: 'srp4',
} as const;

export const GrowthBookServerSideFeatures = {
    SELL_ANOTHER_ITEM: 'GT2131',
    PHONE_MODEL: 'srp_filter_mobile_apple_samsung_model',
    PHONE_MODEL_A: 'srp_filter_mobile_model_google_xiaomi_huawei',
    KEYWORD_CORRECTION: 'GTF-2399',
    SYI_AI_POST: 'syi-ai-post',
    SUG_USE_NEW_RANK: 'sug_use_new_rank',
    SRP_ENTITY_RANK: 'srp_entity_rank',
    SRP_ENTITY_RECALL: 'srp_entity_recall',
    SRP_FILTER_FASHION: 'srp_filter_fashion_condition_colour_material_size',
    SEO_VIP_TOP_SEARCH: 'seo-add-vip-link',
    SRP_VIP_RANK: 'srp_vip_rank',
    SRP_VIP_RECALL: 'srp_vip_recall',
    SRP_RANK_PHASE2: 'srp_rank_phase2',
    SRP_RECALL_PHASE2: 'srp_recall_phase2',
    REMOVE_TOP_SEARCH: 'seo-remove-top-search',
    SEO_EXPIRED_VIP: 'seo-expired-vip',
    // bark synonym search
    BARK_SYNONYM_SEARCH: 'Bark-Synonym-Search',
    BK_TOC_EXP: 'Bk-ToC-Exp',
    SYI_CATEGORY_SELECTION: 'GT-1825',
} as const;
